import { DSP_ASSET_VERSION } from './dspVersion';

/**
 * URL for a static audio-engine asset (WASM, worklet or worker script) that
 * changes whenever any of them does, so a browser never pairs a new page
 * with an old cached engine.
 */
// Chat widgets and the server renderer have their own document origins. Every
// public engine asset must resolve against CookUp, including immutable data.
export const engineAssetUrl = (path) => typeof window !== 'undefined' && window.__COOKUP_CHAT_ENGINE_BASE__
  ? new URL(path, window.__COOKUP_CHAT_ENGINE_BASE__).href
  : path;

export const dspAssetUrl = (path) => `${engineAssetUrl(path)}?v=${DSP_ASSET_VERSION}`;
